import React from 'react';
import config, { unicode } from '@config/index';
import { Body2, Caption, SubH3 } from '@goodfynd/typography';
import { StyledFlex } from '@goodfynd/styles';
import { Link } from '@goodfynd/ui';
import { format, getTimeDisplay } from '@goodfynd/utils';

import { StyledCardContainer, StyledNumber } from './styles';
import type { PreOrderingPinHoverProps } from './types';
export function PreOrderingPinHover({
  item,
  number = 0,
}: PreOrderingPinHoverProps) {
  return (
    <StyledCardContainer
      css={{
        padding: 0,
      }}
    >
      <div className="content" style={{ padding: 0 }}>
        <StyledFlex
          css={{
            alignItems: 'flex-start',
            flexWrap: 'nowrap',
            gap: '1rem',
          }}
        >
          <div>
            <StyledFlex
              css={{
                alignItems: 'flex-start',
                flexWrap: 'nowrap',
                gap: '0.5rem',
              }}
            >
              {number > 0 && <StyledNumber>{number}</StyledNumber>}

              <div>
                <SubH3>
                  {!item.scheduleName ||
                  item.scheduleName === item.scheduleAddress
                    ? `Event #${number}`
                    : item.scheduleName}
                </SubH3>

                <Link
                  href={`https://www.google.com/maps/dir/?api=1&destination=${item.scheduleLocation.coordinates.latitude},${item.scheduleLocation.coordinates.longitude}`}
                >
                  <Caption inherit>{item.scheduleAddress}</Caption>
                </Link>
              </div>
            </StyledFlex>

            <Body2
              style={{ marginTop: '0.5rem' }}
              dangerouslySetInnerHTML={{
                __html: [
                  `${format(
                    item.scheduleStart,
                    config.dateFormats.weekDayMonthDay
                  )}, ${getTimeDisplay(
                    item.scheduleStart,
                    false
                  ).toLowerCase()} - ${getTimeDisplay(
                    item.scheduleEnd,
                    false
                  ).toLowerCase()}`,
                ]
                  .filter(Boolean)
                  .join(unicode.centerDotPadded),
              }}
            >
              {null}
            </Body2>
            <Caption>{item.vendorName}</Caption>
          </div>
        </StyledFlex>
      </div>
    </StyledCardContainer>
  );
}
